import React, { Component } from 'react';

class Plan extends Component {
  render() {
    return (
      <div className="landing container">
        <div className="row">
          <div className="col-12">
              <h1>Your Plan</h1>
          </div>
        </div>

        <div className="row">
            
            <div className="col-6">
                <div className="card planSelected">
                  <h1>Plan 1</h1>
                  <ul>
                      <li>Benefit 1</li>
                      <li>Benefit 1</li>
                      <li>Benefit 1</li>
                      <li>Benefit 1</li>
                      <li>Benefit 1</li>
                      <li>Benefit 1</li>
                      <li>Benefit 1</li>
                  </ul>
                </div>
            </div>
            
            <div className="col-6">
                <div className="card">
                  <h1>Plan 2</h1>
                  <ul>
                      <li>Benefit 1</li>
                      <li>Benefit 1</li>
                      <li>Benefit 1</li>
                      <li>Benefit 1</li>
                      <li>Benefit 1</li>
                      <li>Benefit 1</li>
                      <li>Benefit 1</li>
                  </ul>
                  <div className="btn">Upgrade plan</div>
                </div>
            </div>

        </div>

        <div className="row">
          <div className="col-12">
              <h2>Charity Contribution</h2>

              <div className="card">
                  <p>Charity info here.</p>
                  <div className="btn">Add charity donation</div>
              </div>
          </div>
        </div>

      </div>
    );
  }
}

export default Plan;
